import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SharedDataService } from '../share-data/share-data.service';
import { defaults } from '@app/config';

@Injectable({
  providedIn: 'root'
})
export class FilemanagerPinnableStateService {
  private filemanagerPinned$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(defaults.modalpinned);
  public filemanagerPinnedState$ = this.filemanagerPinned$.asObservable();

  constructor(
    private sharedDataService: SharedDataService,
  ) {
    this.initialState();
   }


  initialState() {
    
    const modalpinned = defaults.modalpinned;
    let initialState = this.sharedDataService.getStoredData('modalpinned') || modalpinned;
    this.filemanagerPinned$.next(initialState);
    
  }

  getState() {
    this.filemanagerPinned$.getValue();
  }

  setState(state: boolean) {
    this.filemanagerPinned$.next(state);
    this.sharedDataService.storeData({
      name: 'modalpinned',
      data: this.filemanagerPinned$.getValue()
    });
  }

  clearState() {
    this.filemanagerPinned$.next(defaults.modalpinned);
    this.sharedDataService.removeStoredData('modalpinned');
  } 

}
